import { useEffect, useState } from "react";
import { Logo } from "@/components/site/Logo";
import { Phone, Download } from "lucide-react";
import { COMPANY } from "@/lib/content";

export const scrollToId = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-navy-800/95 shadow-lg backdrop-blur-md" : "bg-navy/80 backdrop-blur-sm"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 lg:px-8">
        <button onClick={() => scrollToId("top")} data-testid="nav-logo-btn" aria-label="ZERAMI">
          <Logo chip height={34} />
        </button>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={COMPANY.phoneHref}
            data-testid="nav-phone"
            className="hidden items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-white/90 transition-colors hover:text-gold md:flex"
          >
            <Phone className="h-4 w-4 text-gold" />
            {COMPANY.phone}
          </a>
          <a
            href={COMPANY.playStore}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-app"
            className="hidden items-center gap-2 rounded-md border border-white/20 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10 sm:flex"
          >
            <Download className="h-4 w-4" /> App
          </a>
          <button
            data-testid="nav-cta"
            onClick={() => scrollToId("consulenza")}
            className="rounded-md bg-gold px-4 py-2 text-sm font-extrabold uppercase tracking-wide text-navy shadow-sm transition-[background-color,transform] hover:brightness-95 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-navy"
          >
            Consulenza
          </button>
        </div>
      </nav>
    </header>
  );
};
